/**
 * @generated SignedSource<<8b55a657b32e702c487ee96d6feda2bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PractitionersQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PractitionersTableFragment"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentifierType",
        "kind": "LinkedField",
        "name": "allIdentifierTypes",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllIdentifierTypes"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LegalContract",
        "kind": "LinkedField",
        "name": "allLegalContracts",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContractFragments_AllContractsDropdown"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PractitionersQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "firstName",
                "value": null
              },
              {
                "kind": "Literal",
                "name": "lastName",
                "value": null
              },
              {
                "kind": "Literal",
                "name": "legalContractName",
                "value": null
              },
              {
                "kind": "Literal",
                "name": "locationName",
                "value": null
              },
              {
                "kind": "Literal",
                "name": "npi",
                "value": null
              },
              {
                "kind": "Literal",
                "name": "tIN",
                "value": null
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "Practitioner",
        "kind": "LinkedField",
        "name": "filteredPractitioners",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LegalContract",
            "kind": "LinkedField",
            "name": "legalContract",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerIdentifier",
            "kind": "LinkedField",
            "name": "identifiers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentifierType",
                "kind": "LinkedField",
                "name": "identifierType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerVersion",
            "kind": "LinkedField",
            "name": "applicableVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "filteredPractitioners(input:{\"firstName\":null,\"lastName\":null,\"legalContractName\":null,\"locationName\":null,\"npi\":null,\"tIN\":null})"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentifierType",
        "kind": "LinkedField",
        "name": "allIdentifierTypes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "display",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LegalContract",
        "kind": "LinkedField",
        "name": "allLegalContracts",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d6aa58f285ff17c57fe8cba2a48d41c",
    "id": null,
    "metadata": {},
    "name": "PractitionersQuery",
    "operationKind": "query",
    "text": "query PractitionersQuery {\n  ...PractitionersTableFragment\n  allIdentifierTypes {\n    ...Fragments_AllIdentifierTypes\n    id\n  }\n  allLegalContracts {\n    ...ContractFragments_AllContractsDropdown\n    id\n  }\n}\n\nfragment ContractFragments_AllContractsDropdown on LegalContract {\n  id\n  name\n}\n\nfragment Fragments_AllIdentifierTypes on IdentifierType {\n  id\n  display\n}\n\nfragment PractitionersTableFragment on Query {\n  filteredPractitioners(input: {}) {\n    id\n    legalContract {\n      id\n      name\n    }\n    identifiers {\n      identifierType {\n        code\n        id\n      }\n      value\n      id\n    }\n    applicableVersion {\n      displayName\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "17e4ef12ecf58abc9fa13321386a4fcc";

export default node;
